/**
 * ModuleMD PatientPortal API
 * ModuleMD PatientPortal API service
 *
 * OpenAPI spec version: 1.0.0
 * Contact: emrsupport@modulemd.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
    HttpClient, HttpHeaders, HttpParams,
    HttpResponse, HttpEvent
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';
import { Observable } from 'rxjs/Observable';
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { LabOrders, AddPatientPCIFormData } from '../model/models';
import { environment } from '../../environments/environment';

@Injectable()
export class GetPHIDisclosureService {

    protected basePath = environment.appSetting.apiUrl+'patient';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Referenced to SOA.GetPatientPortalMedicationList
     * This API get PatientPortalMedicationList
     */
    public GetPHIDisclosure(patientId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public GetPHIDisclosure(patientId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public GetPHIDisclosure(patientId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public GetPHIDisclosure(patientId: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
       
        let headers = this.defaultHeaders;

        // authentication (api_key) required
        if (this.configuration.apiKeys["Context"]) {
            headers = headers.set('Context', this.configuration.apiKeys["Context"]);
        }

        // authentication (idp_auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml',
            'application/text'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];

        return this.httpClient.get<any>(`${this.basePath}/GetPHIDisclosureByPatientId/`+patientId,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }


    public GetPHIDisclosureSignature(patientId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public GetPHIDisclosureSignature(patientId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public GetPHIDisclosureSignature(patientId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public GetPHIDisclosureSignature(patientId: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });

        let headers = this.defaultHeaders;

        // authentication (api_key) required
        if (this.configuration.apiKeys["Context"]) {
            headers = headers.set('Context', this.configuration.apiKeys["Context"]);
        }

        // authentication (idp_auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml',
            'application/text'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];

        return this.httpClient.get<any>(`${this.basePath}/GetPatientPHIDisclosureSignature/` + patientId,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
                //'responseType': 'arraybuffer' as 'json'
            }
        );
    }

    public GetAcknowledgementForNoticeofPrivacyPracticesByPatientId(patientId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public GetAcknowledgementForNoticeofPrivacyPracticesByPatientId(patientId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public GetAcknowledgementForNoticeofPrivacyPracticesByPatientId(patientId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public GetAcknowledgementForNoticeofPrivacyPracticesByPatientId(patientId: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });

        let headers = this.defaultHeaders;

        // authentication (api_key) required
        if (this.configuration.apiKeys["Context"]) {
            headers = headers.set('Context', this.configuration.apiKeys["Context"]);
        }

        // authentication (idp_auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml',
            'application/text'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];

        return this.httpClient.get<any>(`${this.basePath}/GetAcknowledgementForNoticeofPrivacyPracticesByPatientId/` + patientId,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    public GetAcknowledgementForNoticeofPrivacyPracticesSignature(patientId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public GetAcknowledgementForNoticeofPrivacyPracticesSignature(patientId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public GetAcknowledgementForNoticeofPrivacyPracticesSignature(patientId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public GetAcknowledgementForNoticeofPrivacyPracticesSignature(patientId: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });

        let headers = this.defaultHeaders;

        // authentication (api_key) required
        if (this.configuration.apiKeys["Context"]) {
            headers = headers.set('Context', this.configuration.apiKeys["Context"]);
        }

        // authentication (idp_auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml',
            'application/text'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];

        return this.httpClient.get<any>(`${this.basePath}/GetAcknowledgementForNoticeofPrivacyPracticesSignature/` + patientId,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }


    public PostPHIDisclosure(data: any, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public PostPHIDisclosure(data: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public PostPHIDisclosure(data: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public PostPHIDisclosure(data: any, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });

        let headers = this.defaultHeaders;

        // authentication (api_key) required
        if (this.configuration.apiKeys["Context"]) {
            headers = headers.set('Context', this.configuration.apiKeys["Context"]);
        }

        // authentication (idp_auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml',
            'application/text'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const canConsumeForm = this.canConsumeForm(consumes);

        //let formParams: { append(param: string, value: any): HttpParams; };
        //let useForm = false;
        //let convertFormParamsToString = false;
        //if (useForm) {
        //    // formParams = new FormData();
        //} else {
        //    formParams = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        //}

        //if (data.patientId !== undefined) {
        //    formParams = formParams.append('patientId', <any>data.patientId) || formParams;
        //}
        //if (data.authorizeForAnsweringMachine !== undefined) {
        //    formParams = formParams.append('authorizeForAnsweringMachine', <any>data.authorizeForAnsweringMachine) || formParams;
        //}
        //if (data.specificInstructions !== undefined) {
        //    formParams = formParams.append('specificInstructions', <any>data.specificInstructions) || formParams;
        //}
        //if (data.dateOfVisit !== undefined) {
        //    formParams = formParams.append('dateOfVisit', <any>data.dateOfVisit) || formParams;
        //}
        //if (data.signature !== undefined) {
        //    formParams = formParams.append('signature', <any>data.signature) || formParams;
        //}
        //if (data.isPatientMinor !== undefined) {
        //    formParams = formParams.append('isPatientMinor', <any>data.isPatientMinor) || formParams;
        //}
        //if (data.minorAge !== undefined) {
        //    formParams = formParams.append('minorAge', <any>data.minorAge) || formParams;
        //}
        //if (data.reasonForUnableToSign !== undefined) {
        //    formParams = formParams.append('reasonForUnableToSign', <any>data.reasonForUnableToSign) || formParams;
        //}

        return this.httpClient.put<any>(`${this.basePath}/AddOrUpdatePHIDisclosure`,
            data,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress,
            }
        );
    }


    public PosteAuthorizationToDisclosePHI(data: any, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public PosteAuthorizationToDisclosePHI(data: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public PosteAuthorizationToDisclosePHI(data: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public PosteAuthorizationToDisclosePHI(data: any, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });

        let headers = this.defaultHeaders;

        // authentication (api_key) required
        if (this.configuration.apiKeys["Context"]) {
            headers = headers.set('Context', this.configuration.apiKeys["Context"]);
        }

        // authentication (idp_auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml',
            'application/text'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): HttpParams; };
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            // formParams = new FormData();
        } else {
            formParams = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        }

        if (data.patientId !== undefined) {
            formParams = formParams.append('patientId', <any>data.patientId) || formParams;
        }
        if (data.discloseToName !== undefined) {
            formParams = formParams.append('discloseToName', <any>data.discloseToName) || formParams;
        }
        if (data.relationshipToPatient !== undefined) {
            formParams = formParams.append('relationshipToPatient', <any>data.relationshipToPatient) || formParams;
        }
        if (data.address !== undefined) {
            formParams = formParams.append('address', <any>data.address) || formParams;
        }
        if (data.phone !== undefined) {
            formParams = formParams.append('phone', <any>data.phone) || formParams;
        }
        if (data.discloseAppointmentReminderMessages !== undefined) {
            formParams = formParams.append('discloseAppointmentReminderMessages', <any>data.discloseAppointmentReminderMessages) || formParams;
        }
        if (data.discloseMedicationList !== undefined) {
            formParams = formParams.append('discloseMedicationList', <any>data.discloseMedicationList) || formParams;
        }
        if (data.discloseListOfAllergies !== undefined) {
            formParams = formParams.append('discloseListOfAllergies', <any>data.discloseListOfAllergies) || formParams;
        }


        if (data.discloseImmunizationList !== undefined) {
            formParams = formParams.append('discloseImmunizationList', <any>data.discloseImmunizationList) || formParams;
        }
        if (data.discloseMostRecentHistory !== undefined) {
            formParams = formParams.append('discloseMostRecentHistory', <any>data.discloseMostRecentHistory) || formParams;
        }
        if (data.discloseLaboratoryResults !== undefined) {
            formParams = formParams.append('discloseLaboratoryResults', <any>data.discloseLaboratoryResults) || formParams;
        }
        if (data.discloseXRayAndImagingReports !== undefined) {
            formParams = formParams.append('discloseXRayAndImagingReports', <any>data.discloseXRayAndImagingReports) || formParams;
        }
        return this.httpClient.put<any>(`${this.basePath}/UpdateAuthorizationToDisclosePHI`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    public PostAcknowledgementForNoticeofPrivacyPractices(data: any, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public PostAcknowledgementForNoticeofPrivacyPractices(data: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public PostAcknowledgementForNoticeofPrivacyPractices(data: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public PostAcknowledgementForNoticeofPrivacyPractices(data: any, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });

        let headers = this.defaultHeaders;

        // authentication (api_key) required
        if (this.configuration.apiKeys["Context"]) {
            headers = headers.set('Context', this.configuration.apiKeys["Context"]);
        }

        // authentication (idp_auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml',
            'application/text'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): HttpParams; };
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            // formParams = new FormData();
        } else {
            formParams = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        }

        if (data.patientId !== undefined) {
            formParams = formParams.append('patientId', <any>data.patientId) || formParams;
        }

        if (data.signature !== undefined) {
            formParams = formParams.append('signature', <any>data.signature) || formParams;
        }
        if (data.signedDate !== undefined) {
            formParams = formParams.append('signedDate', <any>data.signedDate) || formParams;
        }
        if (data.relationshipToPatient !== undefined) {
            formParams = formParams.append('relationshipToPatient', <any>data.relationshipToPatient) || formParams;
        }
       
        return this.httpClient.post<any>(`${this.basePath}/AddOrUpdateAcknowledgementForNoticeofPrivacyPractices`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    public GetPCIForms(formId: number, status: number, patientId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<any>>;
    public GetPCIForms(formId: number, status: number, patientId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<any>>>;
    public GetPCIForms(formId: number, status: number, patientId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<any>>>;
    public GetPCIForms(formId: number,status:number,patientId:number,observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (formId !== undefined && formId !== null) {
            queryParameters = queryParameters.set('formId', <any>formId);
        }
        if (status !== undefined && status !== null) {
            queryParameters = queryParameters.set('status', <any>status);
        }
        if (patientId !== undefined && patientId !== null) {
            queryParameters = queryParameters.set('patientId', <any>patientId);
        }


        let headers = this.defaultHeaders;

        // authentication (api_key) required
        if (this.configuration.apiKeys["Context"]) {
            headers = headers.set('Context', this.configuration.apiKeys["Context"]);
        }

        // authentication (idp_auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml',
            'application/text'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): HttpParams; };
        let useForm = false;
        let convertFormParamsToString = false;
       
        return this.httpClient.get<Array<any>>(`${this.basePath}/GetPCIForms`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }


    public GetPatientPCIFormInfo(formId: number,  patientId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public GetPatientPCIFormInfo(formId: number,  patientId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public GetPatientPCIFormInfo(formId: number,  patientId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public GetPatientPCIFormInfo(formId: number,  patientId: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        //if (formId !== undefined && formId !== null) {
        //    queryParameters = queryParameters.set('formId', <any>formId);
        //}
       
        //if (patientId !== undefined && patientId !== null) {
        //    queryParameters = queryParameters.set('patientId', <any>patientId);
        //}


        let headers = this.defaultHeaders;

        // authentication (api_key) required
        if (this.configuration.apiKeys["Context"]) {
            headers = headers.set('Context', this.configuration.apiKeys["Context"]);
        }

        // authentication (idp_auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml',
            'application/text'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
      

        return this.httpClient.get<any>(`${this.basePath}/GetPatientPCIFormInfo/` + formId+'/'+patientId,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }



    public AddPatientPCIFormInfo(patientpciformdata: AddPatientPCIFormData, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public AddPatientPCIFormInfo(patientpciformdata: AddPatientPCIFormData, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public AddPatientPCIFormInfo(patientpciformdata: AddPatientPCIFormData, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public AddPatientPCIFormInfo(patientpciformdata: AddPatientPCIFormData, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });

        let headers = this.defaultHeaders;

        // authentication (api_key) required
        if (this.configuration.apiKeys["Context"]) {
            headers = headers.set('Context', this.configuration.apiKeys["Context"]);
        }

        // authentication (idp_auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml',
            'application/text'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): HttpParams; };
        let useForm = false;
        let convertFormParamsToString = false;
        if (useForm) {
            // formParams = new FormData();
        } else {
            formParams = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        }

       

        return this.httpClient.post<any>(`${this.basePath}/AddPatientPCIFormInfo`,
            patientpciformdata,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }


    public GetPatientPCIFormSignature(patientId: number, formId:number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });

        let headers = this.defaultHeaders;

        // authentication (api_key) required
        if (this.configuration.apiKeys["Context"]) {
            headers = headers.set('Context', this.configuration.apiKeys["Context"]);
        }

        // authentication (idp_auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml',
            'application/text'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];

        return this.httpClient.get<any>(`${this.basePath}/GetPatientPCIFormSignature/` + formId +`/`+ patientId,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
                //'responseType': 'arraybuffer' as 'json'
            }
        );
    }
}
